import React from 'react'
import HeroBanner from '../component/Common Banner Component/HeroBanner'
import Footer from '../component/Footer/Footer'
import InteriorDesign from '../component/InteriorDesign/InteriorDesign'
import GetInTouch from '../component/GetInTouch/GetInTouch'
import { Helmet } from 'react-helmet'
import SalesCard from '../component/SalesCard/SalesCard'

const cardData = [
    {
        title:"Staging Consultation (vacant or occupied) - $495 (up to 3 hours max)",
        list:[
            "In-home or virtual walk-through with the homeowner",
            "Design guidance on layout, colour, furniture, and lighting",
            "Styling recommendation with existing décor (for occupied property)",
            "Room Ready Handbook with recommendations or a list of suggested improvements",
            "Summary presentation with main recommendations",
            "Add-on: Accessory rental package (starting at +$400)",
        ]
    },
    {
        title:"Vacant Home Staging - Starting at $2,995 ",
        list:[
            "Furniture & decor rental from MES Décors inventory",
            "Styling for up to 3 main areas (living, dining, kitchen/breakfast area)",
            "Delivery, setup & pickup included",
            "Additional rooms: +$300/room (Excluding Rentals)",
            "30-day rental term (extendable)",

        ]
    },
    {
        title:"Occupied Home Staging - Starting at $1990",
        list:[
            "Furniture & decor rental from MES Décors inventory (if needed)",
            "Working with the homeowner’s furniture, decor and accessories (when applicable)",
            "Styling for up to 3 main areas (living, dining, kitchen/breakfast area)",
            "Delivery, setup & pickup included",
            "Additional rooms: +$300/room (Excluding Rentals)",
            "30-day rental term (extendable)",
        ]
    },

]

function Stagging() {
    return (
        <>
         <Helmet>
          <title> 
          Professional Home Staging Services | Best home staging & Interior Design consultation - Canada
          </title>
          <meta 
          name='description' 
          content="Elevate your property's appeal with expert home staging and staging & Interior Design consultation service  in Canada .Tailored designs for homes, new builds, and model homes to attract buyers and boost sales." 
          />
          <link rel="canonical" href="https://www.mesdecors.ca/staging" />


        </Helmet>
        
            <HeroBanner 
                subHeading=""
                Heading="PROFESSIONAL HOME STAGING SERVICE"
                nextLineSpanHeading=""
                Paragraph="Elevate your property's appeal and maximize its value with our professional staging services. From strategic furniture placement to eye-catching decor, we'll help you make a lasting impression."
                bgImg="/images/creatives/stagging-hero-bg.jpg"
                btn={false}
                sideLinks={false}
            />
    
          <InteriorDesign/>

          
          <SalesCard
          heading="Home Staging Packages"
            cardData={cardData}
            noteText="Prices can be adjusted based on square footage, urgency, and location."
          />
           
          <GetInTouch heading="LET'S START STAGING TODAY!"/>
          <Footer
            newsletterSection={true}
          />
        </>
      )
}

export default Stagging